import { useParams } from "react-router-dom"

export const Checkout = () => {
    const {roomId} = useParams();
    return (
        <div>{roomId} has been selected</div>
    )

}
